// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"132":"forms","794":"section-contact-form"}[chunkId] + "." + {"132":"0506ad1d0d54af698c9c","794":"0506ad1d0d54af698c9c"}[chunkId] + ".css";
};